export default "__VITE_ASSET__h8CU6PHz__"